import { Grid } from "@mui/material"
import { GeneralStats } from "./GeneralStats"
import { useEffect, useState } from "react"
import { SkeletonVelesDashView } from "../../../../components/skeleton-veles/SkeletonVelesDashView"
import { TopConsumoSection } from "./TopConsumoSection"
import { useAppSelector } from "../../../../hooks/store-hooks"

export const DashboardHome = () => {
  // Use State
  const [loading, setLoading] = useState(true)

  // Dashboard Redux state
  const {
    topClientesDaily,
    topUsuariosDaily,
    topProdutosDaily,
    topVariaveisDaily,
    topClientesTotal,
    topUsuariosTotal,
    topProdutosTotal,
    topVariaveisTotal
  } = useAppSelector((state) => state.dashboardSummary)

  // Use Effect
  useEffect(() => {
    setLoading(false)
  }, [])

  return (
    loading ? (
      <SkeletonVelesDashView />
    ) : <>
      <Grid container spacing={3}>
        {/* Cards de estatísticas gerais */}
        <Grid item xs={12}>
          <GeneralStats />
        </Grid>

        {/* Tabelas de Top Consumo por Categoria (Diário & Mensal lado a lado) */}
        <Grid item xs={12}>
          <TopConsumoSection
            categoryName="CLIENTE"
            dailyData={topClientesDaily}
            monthlyData={topClientesTotal}
          />
        </Grid>

        <Grid item xs={12}>
          <TopConsumoSection
            categoryName="USUÁRIO"
            dailyData={topUsuariosDaily}
            monthlyData={topUsuariosTotal}
          />
        </Grid>

        <Grid item xs={12}>
          <TopConsumoSection
            categoryName="PRODUTO"
            dailyData={topProdutosDaily}
            monthlyData={topProdutosTotal}
          />
        </Grid>

        <Grid item xs={12}>
          <TopConsumoSection
            categoryName="VARIÁVEL"
            dailyData={topVariaveisDaily}
            monthlyData={topVariaveisTotal}
          />
        </Grid>
      </Grid>
    </>
  )
}